module.exports = __webpack_public_path__ + "static/media/KY.b7acd796.svg";